/**
 * Vendor Inventory Tracking
 * For product and supply tracking across all item categories
 * (fabrics, decor, favours, tableware, equipment, etc.)
 * Separate from ParsedVendor (which is for service vendors).
 */

export type InventoryCategory =
  | 'fabric'
  | 'favour'
  | 'decor'
  | 'stationery'
  | 'clothing'
  | 'tableware'
  | 'lighting'
  | 'floral'
  | 'food'
  | 'equipment'
  | 'other';

export interface InventoryProduct {
  readonly id: string;
  vendorId: string;
  productCode: string;         // e.g. "C18", "A06"
  name: string;                // human-readable name
  category: InventoryCategory;
  available: boolean;
  stock?: number;              // units if known
  notes?: string;
  imageUrl?: string;
  lastUpdated: string;         // ISO date
  updatedBy: 'whatsapp_brief' | 'manual' | 'portal';
}

export interface PriceEntry {
  readonly id: string;
  productId: string;
  vendorId: string;
  priceNgn: number;
  vendorLabel: string;         // e.g. "old vendor", "new vendor", "direct"
  validFrom: string;           // ISO date
  validTo?: string;            // ISO date, null = currently valid
  source: string;              // e.g. "WhatsApp Apr 14", "manual"
}

export interface InventoryVendor {
  readonly id: string;
  name: string;                // e.g. "INSIDETRACK POP-UP"
  phone?: string;
  whatsappGroup?: string;      // group name e.g. "INSIDETRACK POP-UP"
  category: InventoryCategory | 'mixed';
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface InventorySnapshot {
  readonly id: string;
  vendorId: string;
  takenAt: string;             // ISO datetime
  source: 'whatsapp_brief' | 'manual';
  products: Array<{
    productCode: string;
    available: boolean;
    priceNgn?: number;
    vendorLabel?: string;
    notes?: string;
  }>;
  rawMessage?: string;         // original WhatsApp message if from brief
}

// localStorage keys
export const INVENTORY_VENDORS_KEY  = 'anojeje_inventory_vendors';
export const INVENTORY_PRODUCTS_KEY = 'anojeje_inventory_products';
export const INVENTORY_PRICES_KEY   = 'anojeje_inventory_prices';
export const INVENTORY_SNAPSHOTS_KEY = 'anojeje_inventory_snapshots';
